import { useQueries } from '@tanstack/react-query';
import drEasyApi from '../Api/Customapi';

const fetcher = (url, params) =>
  drEasyApi.get(url, { params }).then((r) => r.data ?? []);

export function useCenterData(centerId, language) {
  const enabled = !!centerId;

  const results = useQueries({
    queries: [
      {
        queryKey: ['reviews', centerId, language],
        queryFn: () => fetcher('/api/Review/GetReviews', { CenterId: centerId }),
        enabled,
        staleTime: 5 * 60 * 1000,
      },
      {
        queryKey: ['services', centerId, language],
        queryFn: () => fetcher('/api/Services/GetCenterServices', { CenterId: centerId }),
        enabled,
        staleTime: 5 * 60 * 1000,
      },
      {
        queryKey: ['packages', centerId, language],
        queryFn: () =>
          fetcher(`/api/Packages/GetByCenterId`, { CenterId: centerId }).then((data) =>
            (data || []).map((pkg) => ({ ...pkg, items: pkg.services ?? pkg.items ?? [] }))
          ),
        enabled,
        staleTime: 5 * 60 * 1000,
      },
      {
        queryKey: ['blogs', centerId, language],
        queryFn: () => fetcher('/api/Blogs/GetCenterBlogs', { CenterId: centerId }),
        enabled,
        staleTime: 5 * 60 * 1000,
      },
      {
        queryKey: ['news', centerId, language],
        queryFn: () => fetcher('/api/CenterNews/GetCenterNews', { CenterId: centerId }),
        enabled,
        staleTime: 5 * 60 * 1000,
      },
      {
        queryKey: ['doctors', centerId, language],
        queryFn: () =>
          fetcher('/api/Centers/GetCenterDoctors', { CenterId: centerId }).then(
            (d) => d?.doctors ?? d ?? []
          ),
        enabled,
        staleTime: 5 * 60 * 1000,
      },
      {
        queryKey: ['overview', centerId],
        queryFn: () => fetcher('/api/Centers/GetCenterOverview', { CenterId: centerId }),
        enabled,
        staleTime: 10 * 60 * 1000,
      },
    ],
  });

  const [reviews, services, packages, blogs, news, doctors, overview] = results;

  return {
    reviews:   { data: reviews.data   ?? [], isLoading: reviews.isLoading   },
    services:  { data: services.data  ?? [], isLoading: services.isLoading  },
    packages:  { data: packages.data  ?? [], isLoading: packages.isLoading  },
    blogs:     { data: blogs.data     ?? [], isLoading: blogs.isLoading     },
    news:      { data: news.data      ?? [], isLoading: news.isLoading      },
    doctors:   { data: doctors.data   ?? [], isLoading: doctors.isLoading   },
    overview:  { data: overview.data  ?? null, isLoading: overview.isLoading },
    isLoading: results.some((r) => r.isLoading),
  };
}